"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const LoadingIndicator_1 = require("../../home/LoadingIndicator");
const MobilePopover_1 = require("../components/MobilePopover");
const Row_1 = require("../components/Row");
const SegmentConditionSelector = ({ activePopover, closePopoverModalForm, device, isPopoverModalFormOpen, segment, shouldShowDeviceListOption, totalAudienceSize, updateActivePopover, updateDevicePredicateSegment, updateSegmentCondition, createSegmentDeviceList, updateSegmentToAllDevices, deviceListKeyPaths, }) => {
    const updatePopoverVisibility = () => {
        if (activePopover === 'segment-selector') {
            closePopoverModalForm();
            setTimeout(() => {
                updateActivePopover('');
            }, device === 'Mobile' ? 500 : 0);
            return;
        }
        updateActivePopover('segment-selector');
    };
    const renderCurrentSegmentCondition = () => {
        if (!segment) {
            return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                React.createElement(src_1.Text, { text: "Send notification to all devices", size: "large", textStyle: { color: src_1.charcoal } }),
                typeof totalAudienceSize === 'number' ? (React.createElement(src_1.Text, { text: `${totalAudienceSize} devices`, size: "small", label: true, textStyle: { color: src_1.steel } })) : (React.createElement(LoadingIndicator_1.default, null))));
        }
        switch (segment.__typename) {
            case 'CompoundSegment':
                return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                    React.createElement(src_1.Text, { text: "Send notification to devices who belong to...", label: true, size: "small" }),
                    React.createElement("div", null,
                        React.createElement(src_1.Text, { text: segment.condition, size: "large", textStyle: Object.assign(Object.assign({}, src_1.semibold), { color: src_1.charcoal, marginRight: 5 }) }),
                        React.createElement(src_1.Text, { text: "of the following segments", size: "large", textStyle: { color: src_1.charcoal } }))));
            case 'DeviceListSegment':
            case 'DevicePredicateSegment':
                return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                    React.createElement(src_1.Text, { text: "Send notification to...", label: true, size: "small" }),
                    React.createElement(src_1.Text, { text: segment.__typename === 'DeviceListSegment'
                            ? 'A list of devices'
                            : 'A segment of devices', size: "large", textStyle: { color: src_1.charcoal } })));
            default:
                return;
        }
    };
    const renderV1SegmentCondition = (condition) => (React.createElement("div", { key: condition, onClick: (e) => {
            e.stopPropagation();
            updateSegmentCondition(condition);
            updatePopoverVisibility();
        }, style: {
            display: 'flex',
            height: device !== 'Mobile' ? 55 : 71,
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
        } },
        React.createElement(src_1.AudienceIcon, { width: "24", height: "24", viewBox: "0 0 72 72" }),
        React.createElement("div", { style: {
                flexGrow: 1,
                marginLeft: 8,
            } },
            React.createElement(src_1.Text, { text: condition, size: "large", textStyle: Object.assign(Object.assign({}, src_1.semibold), { marginRight: 5 }) }),
            React.createElement(src_1.Text, { text: "of the following segments", size: "large" })),
        React.createElement(src_1.RadioButton, { selected: segment && segment.condition === condition, style: {
                outerStyle: { height: 18, width: 18 },
            } })));
    const renderV2SegmentCondition = (segmentType) => {
        const getText = () => {
            switch (segmentType) {
                case 'DevicePredicateSegment':
                    return 'A segment of devices';
                case 'DeviceListSegment':
                    return 'A list of devices';
                default:
                    return 'All devices';
            }
        };
        const clickHandler = () => {
            switch (segmentType) {
                case 'DevicePredicateSegment':
                    return updateDevicePredicateSegment();
                case 'DeviceListSegment':
                    return createSegmentDeviceList({
                        deviceList: { id: '' },
                        keyPath: deviceListKeyPaths[0],
                    });
                default:
                    return updateSegmentToAllDevices();
            }
        };
        return (React.createElement("div", { key: segmentType, onClick: (e) => {
                e.stopPropagation();
                updatePopoverVisibility();
                clickHandler();
            }, style: {
                display: 'flex',
                height: device !== 'Mobile' ? 55 : 71,
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            React.createElement(src_1.Text, { text: getText(), size: "large" }),
            React.createElement(src_1.RadioButton, { selected: !!segmentType ? segment && segment.__typename === segmentType : segment === null, style: {
                    outerStyle: { height: 18, width: 18 },
                } })));
    };
    const renderConditions = () => (React.createElement("div", { style: { flex: '1 1 auto', overflowY: 'scroll' } },
        React.createElement(src_1.SelectableList, { device: device },
            renderV2SegmentCondition('DevicePredicateSegment'),
            shouldShowDeviceListOption && renderV2SegmentCondition('DeviceListSegment'),
            renderV2SegmentCondition(),
            renderV1SegmentCondition('ANY'),
            renderV1SegmentCondition('ALL'))));
    return (React.createElement(Row_1.default, { onClick: updatePopoverVisibility },
        renderCurrentSegmentCondition(),
        device !== 'Mobile' ? (React.createElement(src_1.PopoverContainer, { id: "segment-selector-popover", popoverProps: {
                placement: 'left',
                device: device,
                navBarProperties: {
                    buttonLeft: 'Cancel',
                    buttonLeftCallback: () => {
                        updatePopoverVisibility();
                    },
                },
            }, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', onClick: updatePopoverVisibility, showPopover: activePopover === 'segment-selector' },
            device === 'Desktop' ? (React.createElement(src_1.Button, { text: "Change", type: "regular", mouseDownColors: {
                    active: src_1.turquoise,
                    inactive: src_1.aquamarine,
                }, key: "segment-condition-selector" })) : (React.createElement(src_1.ChangeIcon, { fill: src_1.titanium })),
            React.createElement("div", { style: {
                    width: 384,
                    display: 'flex',
                    flexDirection: 'column',
                } }, renderConditions()))) : (React.createElement(React.Fragment, null, activePopover === 'segment-selector' &&
            ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: {
                    buttonLeft: 'Cancel',
                    buttonLeftCallback: updatePopoverVisibility,
                } },
                React.createElement("div", { style: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    } },
                    React.createElement(src_1.Text, { size: "h2", text: "Send notification to\u2026", textStyle: { margin: 24 } }),
                    renderConditions())), document.getElementById('mainModalLeft'))))));
};
const mapStateToProps = (state) => {
    const settings = reducers_1.getSettings(state);
    return {
        activePopover: reducers_1.getActivePopover(state),
        isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
        segment: reducers_1.getEditableCampaignSegment(state),
        shouldShowDeviceListOption: reducers_1.getShouldShowDeviceListOption(state),
        totalAudienceSize: reducers_1.getTotalAudienceSize(state),
        deviceListKeyPaths: settings ? settings.keyPaths : [],
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
        updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
        updateDevicePredicateSegment: (predicate) => dispatch(actions_1.updateDevicePredicateSegment(predicate)),
        updateSegmentCondition: (condition) => dispatch(actions_1.updateSegmentCondition(condition)),
        createSegmentDeviceList: (deviceList) => dispatch(actions_1.createSegmentDeviceList(deviceList)),
        updateSegmentToAllDevices: () => dispatch(actions_1.updateSegmentToAllDevices()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SegmentConditionSelector);
